import { render, staticRenderFns } from "./parcel_weighing.vue?vue&type=template&id=ba5c622e&"
import script from "./parcel_weighing.vue?vue&type=script&lang=js&"
export * from "./parcel_weighing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports